import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import Pagination from 'ati-ui-react/widgets/Pagination';
import decline from 'utils/decline';
import { IPagination } from 'interfaces/IPagination';
import { useStores } from 'hooks/useStores';
import PaginationStep from './components/PaginationStep';
import DateOfAnnouncement from '../../MainPage/components/Search/components/DateOfAnnouncement';

import {
  TopPaginationMenuStyles,
  BottomPaginationMenuStyles,
  DateOfAnnouncementBox,
  LeftSide,
  RigthSide,
} from './PaginationMenuStyles';

interface IPaginationMenu {
  pagination: IPagination;
  position: string;
  showStep: boolean;
}

const PaginationMenu: FC<IPaginationMenu> = observer(({ pagination, position, showStep }) => {
  const {
    appStore: { isMobile, isTablet },
  } = useStores();

  const setPage = ({ selected }: { selected: number }): void => {
    pagination.setPage(selected);
  };

  useEffect(() => {
    return () => {
      pagination.resetPage();
      pagination.resetLimit();
    };
  }, []);

  if (!pagination) return null;

  const header = isMobile || isTablet ? 'Выводить' : 'Выводить объявлений';

  if (position === 'top') {
    return (
      <TopPaginationMenuStyles>
        <LeftSide>
          <span className="total-count">
            {`${pagination.countAdverts} ${decline(pagination.countAdverts, [
              'объявление',
              'объявления',
              'объявлений',
            ])} найдено`}
          </span>

          <div className="pagination-wrapper">
            <DateOfAnnouncementBox>
              <DateOfAnnouncement />
            </DateOfAnnouncementBox>
          </div>
        </LeftSide>

        <RigthSide>
          <div className="pagination-step">
            <PaginationStep pagination={pagination} header="" />
          </div>
          {pagination.countPages > 1 && (
            <div className="pagination">
              <Pagination
                initialPage={pagination.page}
                pageCount={pagination.countPages}
                onPageChange={setPage}
              />
            </div>
          )}
        </RigthSide>
      </TopPaginationMenuStyles>
    );
  }

  return (
    <>
      {
        <BottomPaginationMenuStyles>
          {pagination.countPages > 1 && (
            <div className="pagination">
              <Pagination
                initialPage={pagination.page}
                pageCount={pagination.countPages}
                onPageChange={setPage}
                total={!isMobile}
              />
            </div>
          )}
          {showStep && (
            <div className="pagination-step">
              <PaginationStep pagination={pagination} header={header} />
            </div>
          )}
        </BottomPaginationMenuStyles>
      }
    </>
  );
});

export default PaginationMenu;
